module.exports = function getResource(label, vars = []) {
    let resources = {
        copyright: `© ${vars[0]}`,
        allRightReserved: 'Sephora USA, Inc. Tous droits réservés.',
        termsOfUse: 'les conditions d’utilisation et les',
        privacyPolicy: 'Politique de confidentialité',
        phoneNumber1: '1-877-SEPHORA (1-877-737-4672)',
        phoneNumber2: 'ATS (1-888-866-9845)',
        findAStore: 'Trouver un magasin',
        chat: 'Clavardage avec le service à la clientèle',
        getTheApp: 'Obtenez l’appli',
        textApp: `Textez « APP » au ${vars[0]}`,
        regionAndLanguage: 'Région et langue',
        downloadApp: 'Téléchargez l’appli Sephora',
        siteMap: 'Plan du site',
        accessibility: 'Accessibilité',
        iOSBanner: 'Téléchargez l’appli Sephora | Télécharger sur l’App Store > pour iOS',
        googlePlayBanner: 'Téléchargez l’appli Sephora | Disponible sur Google Play > pour Android',
        belong: 'Quelque chose de beau nous unit.',
        weBelong: 'Quelque chose de beau',
        somethingBeautiful: 'nous unit'
    };

    return resources[label];
};
